"use client";

import React, { useState } from "react";
import { Clock, Copy, MapPin, Phone, Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function FindUsInTheCity() {
  const [isCopied, setIsCopied] = useState(false);
  const address = "1803 Briar Creek Blvd, Safety Harbor, FL 34695";
  const phone = "727-216-0505";
  const hours = "Mon–Fri 9am–5pm | Saturday 10am–1pm | Sunday Closed";
  const handleCopyAddress = () => {
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      navigator.clipboard.writeText(address).then(() => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
      });
    }
  };
  return <section data-section-id="221596" id="find-us-reach-out" className="bg-background text-foreground py-16 md:py-24 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          <div className="relative w-full h-[400px] lg:h-[600px] bg-muted overflow-hidden border border-border shadow-lg rounded-2xl">
            <iframe src="https://maps.google.com/maps?q=1803%20Briar%20Creek%20Blvd,%20Safety%20Harbor,%20FL%2034695&t=&z=15&ie=UTF8&iwloc=&output=embed" className="w-full h-full border-0" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Polmed Primary Care Clinic Location" />
          </div>

          <div className="flex flex-col justify-center space-y-12">
            <div>
              <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight mb-6 text-primary">
                Visit Our Safety Harbor Clinic
              </h2>
              <p className="font-sans text-muted-foreground text-lg max-w-md leading-relaxed">
                Experience professional primary care and walk-in services in a modern, welcoming environment designed for your comfort and health.
              </p>
            </div>

            <div className="space-y-10">
              <div className="flex items-start gap-5 group">
                <div className="p-3 bg-accent/50 border border-border transition-all group-hover:bg-accent group-hover:border-ring/30 rounded-xl">
                  <Clock className="w-6 h-6 text-primary" strokeWidth={1.5} />
                </div>
                <div className="pt-1">
                  <p className="font-sans text-xs text-muted-foreground uppercase tracking-widest mb-2 font-semibold">
                    Clinical Hours
                  </p>
                  <p className="font-default text-2xl md:text-3xl font-bold text-foreground">
                    {hours}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5 group">
                <div className="p-3 bg-accent/50 border border-border transition-all group-hover:bg-accent group-hover:border-ring/30 rounded-xl">
                  <Phone className="w-6 h-6 text-primary" strokeWidth={1.5} />
                </div>
                <div className="pt-1">
                  <p className="font-sans text-xs text-muted-foreground uppercase tracking-widest mb-2 font-semibold">
                    Direct Line
                  </p>
                  <Link to={`tel:${phone.replace(/-/g, "")}`} className="font-default text-2xl md:text-3xl font-bold text-foreground hover:text-ring transition-colors inline-block">
                    {phone}
                  </Link>
                </div>
              </div>

              <div className="flex items-start gap-5 group">
                <div className="p-3 bg-accent/50 border border-border transition-all group-hover:bg-accent group-hover:border-ring/30 rounded-xl">
                  <MapPin className="w-6 h-6 text-primary" strokeWidth={1.5} />
                </div>
                <div className="pt-1 flex-1">
                  <p className="font-sans text-xs text-muted-foreground uppercase tracking-widest mb-2 font-semibold">
                    Find Us
                  </p>
                  <div className="flex items-center gap-4 flex-wrap">
                    <Link to={`https://maps.google.com/?q=${encodeURIComponent(address)}`} newTab className="font-default text-2xl md:text-3xl font-bold text-foreground hover:text-ring transition-colors">
                      {address}
                    </Link>
                    <Button variant="outline" size="icon" onClick={handleCopyAddress} className="h-10 w-10 shrink-0 border-border hover:bg-accent hover:text-ring transition-all rounded-full" title="Copy Clinic Address" aria-label="Copy Clinic Address">
                      {isCopied ? <Check className="w-5 h-5 text-ring" strokeWidth={2.5} /> : <Copy className="w-5 h-5 text-muted-foreground" strokeWidth={1.5} />}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}